import { getUrlParamByKey, UrlParamKey } from '../utils/url-params-helper';
import { useMerchantInfo } from '../store/merchant-info-module';
import { VIN } from '../utils/vin';
import { userEnv } from '@tencent/wphk-base-utils';
export const useGlobalBi = () => {
  const fareaid = getUrlParamByKey(UrlParamKey.area);
  const fsceneid = getUrlParamByKey(UrlParamKey.sceneId);
  /** 是否非香港钱包用户，从登陆拦截中带过来的，看login.ts */
  const isNotHkUser = getUrlParamByKey(UrlParamKey.isNotHkUser);
  const fminiprogram = userEnv.getMiniProgramAppId();
  const getBiExt = () => {
    const { spId, merchantId } = useMerchantInfo();
    return {
      /** 商户标识 */
      fmerchantid: merchantId,
      /** 打开场景值 */
      fsceneid,
      /** 地区标识 */
      fareaid,
      /** 商户号 */
      fspid: spId,
      /** 是否香港钱包用户(1-非香港钱包，0-是香港钱包） */
      fnothkuser: isNotHkUser || '0',
      /** 用户虚拟id */
      fvin: VIN,
      fminiprogram,
    };
  };
  return {
    getBiExt,
  };
};
